import { useState } from 'react'
import styles from './DistinctSizesUploader.css'
import { Button, Modal } from '@vzmi/shp_shared_compo'
import { Row, Col, Button as AntdBtn } from 'antd'
import { ProductsTableHeader } from '../../../UpdateListing/ImageFunctionTable/ImageFunctionTable'
import _ from 'lodash'
import AvatarUploader from '../AvatarUploader/AvatarUploader'

export const DEFAULT_DISTINCT_DIMENSIONS = [
  400, 250, 135, 80
]

const DEFAULT_IMAGES = DEFAULT_DISTINCT_DIMENSIONS.map(size => ({
  width: size,
  height: size,
  order: 1
}))

const DistinctSizesUploader = props => {
  const {
    readOnly,
    disabled,
    updateFirstOrderImages,
    activePrimaryImage = {
      currentImages: DEFAULT_IMAGES
    }
  } = props

  const currentImages = _.get(activePrimaryImage, 'currentImages', DEFAULT_IMAGES)

  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <section className={styles.uploadBtnArea}>
        <Button
          buttonType='outline'
          data-role='upload-distinct-size-image-btn'
          disabled={disabled}
          className={styles.uploadBtn}
          onClick={() => setShowModal(!showModal)}
        >
          上傳個別尺寸
        </Button>
      </section>
      <Modal
        closable
        disableFooter
        destroyOnClose
        width={580}
        title='主圖個別尺寸'
        visible={showModal}
        onCancel={() => setShowModal(false)}
        className={styles.distinctSizeModal}
      >
        <section>
          <ProductsTableHeader>
            <Col span={4}> 尺寸</Col>
            <Col span={4}> 圖片</Col>
            <Col span={12} />
          </ProductsTableHeader>
          <section className={styles.tableBody}>
            {
              currentImages.map(
                (imgObj, idx) => {
                  const {
                    width,
                    url = ''
                  } = imgObj

                  const sizeDimension = `${width}x${width}`

                  const defaultImgUrl = _.get(activePrimaryImage, `defaultImages[${idx}].url`, null)
                  const noDefaultImgUrl = defaultImgUrl === null
                  const isUsingDefaultImg = url === defaultImgUrl

                  const handleToDefault = () => {
                    const cloneImages = _.cloneDeep(activePrimaryImage)
                    cloneImages.currentImages[idx].url = defaultImgUrl
                    updateFirstOrderImages(cloneImages)
                  }

                  const handleRemove = () => {
                    const cloneImages = _.cloneDeep(activePrimaryImage)
                    cloneImages.currentImages[idx].url = null
                    updateFirstOrderImages(cloneImages)
                  }

                  const handleSingleUploaded = uploadedFileList => {
                    // 新上傳的會在 uploadedFileList 往後加疊
                    // 所以每次取最後一筆即是最新上傳的圖片
                    const lastUpdatedIndex = _.size(uploadedFileList) - 1
                    const uploadedUrl = _.get(uploadedFileList, `[${lastUpdatedIndex}].url`)
                    const cloneImages = _.cloneDeep(activePrimaryImage)
                    _.set(cloneImages, `currentImages[${idx}].url`, uploadedUrl)
                    updateFirstOrderImages(cloneImages)
                  }

                  return (
                    <Row
                      type='flex'
                      align='middle'
                      justify='space-between'
                      className={styles.imgRow}
                      key={`image_${idx}_${sizeDimension}`}
                    >
                      {/* 尺寸 */}
                      <Col
                        span={4}
                        className={styles.imageSizeCell}
                      >
                        <div className={styles.imageSizeDimension}>
                          {sizeDimension}
                        </div>
                      </Col>
                      {/* 圖片 */}
                      <Col span={4}>
                        <AvatarUploader
                          readOnly={readOnly}
                          rule={{ minDimension: width }}
                          imageUrl={url}
                          onAllFileUploaded={handleSingleUploaded}
                          onUpdateFile={handleSingleUploaded}
                        />
                      </Col>
                      {/* 恢復預設, 更換圖片, 刪除 */}
                      <Col
                        span={8}
                        offset={4}
                      >
                        <Row
                          type='flex'
                          align='middle'
                          justify='space-between'
                          className={styles.actionRow}
                        >
                          <AntdBtn
                            ghost
                            type='primary'
                            disabled={
                              (noDefaultImgUrl || isUsingDefaultImg) ||
                            readOnly
                            }
                            onClick={handleToDefault}
                          >
                            恢復預設
                          </AntdBtn>
                          <AntdBtn
                            ghost
                            disabled={!url || readOnly}
                            type='primary'
                            onClick={handleRemove}
                          >
                            刪除
                          </AntdBtn>
                        </Row>
                      </Col>
                    </Row>
                  )
                })
            }
          </section>

        </section>

      </Modal>
    </>
  )
}

export default DistinctSizesUploader
